export default __webpack_public_path__ + "static/media/no_recommended_replacement_sm.a16fb6c8.svg";